var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#1D7DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81818 28H25.5758M25.1533 23.2327L27.4741 13.5314C27.6761 12.6872 26.7803 12.0042 26.0197 12.4225L22.7613 14.2146C22.2991 14.4688 21.719 14.3203 21.4358 13.8753L18.6069 9.42992C18.1981 8.78753 17.25 8.81949 16.8854 9.48795L14.5411 13.7857C14.276 14.2717 13.6664 14.4499 13.1813 14.1831L9.98033 12.4225C9.21971 12.0042 8.32388 12.6871 8.52585 13.5314L10.8467 23.2327C10.9544 23.6826 11.3566 24 11.8193 24H24.1807C24.6434 24 25.0456 23.6826 25.1533 23.2327Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/Subscribe.9e43d38e9e79155b3825ee88ea2d7bdd.svg";
export { ForwardRef as ReactComponent };